import IFilter from '../ifilter';

export default class FormatChannelFilter implements IFilter {
    public filterName;

    constructor() {
        this.filterName = 'formatChannel';
    }

    public filterAction(channel: string) {
        if (channel === 'GUICHE' || channel === 'NETVIAGEM') {
            return 'Buson';
        }
        if (channel === 'WHITELABEL' || channel === 'WHITELABEL_NETVIAGEM') {
            return 'Meu site';
        }
        return channel;
    }

}
